import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { ClockIcon, CalendarIcon, ZapIcon, FileTextIcon } from 'lucide-react';
export function ContentSection() {
  const items = [{
    title: 'El Protocolo Diario de 10 Minutos',
    subtitle: '(paso a paso)',
    icon: ClockIcon,
    details: ['3 minutos de respiración guiada (exhalo largo)', '4 minutos de movimiento simple (sin equipo)', '2 minutos de regulación sensorial (eliges 1)', '1 minuto de cierre mental (guion listo)']
  }, {
    title: 'Rutina completa de 7 días',
    subtitle: '(10–15 min)',
    icon: CalendarIcon,
    details: ['Día por día: qué hacer', 'Qué esperar sentir (realista)', 'Cómo adaptarlo si estás muy activado/a']
  }, {
    title: 'Protocolo de Emergencia',
    subtitle: '(5 minutos)',
    icon: ZapIcon,
    details: ['Para picos en el trabajo', 'En el carro (estacionado)', 'Antes de una llamada/reunión', 'En el supermercado']
  }, {
    title: 'Extras imprimibles',
    subtitle: 'Herramientas visuales',
    icon: FileTextIcon,
    details: ['Tarjetas del Protocolo 3C', 'Semáforo de activación (rojo/ámbar/verde)', 'Checklist de señales tempranas', 'Plantillas de seguimiento de 1 minuto']
  }];
  return <Section id="content" background="white" data-id="element-75">
      <div className="text-center mb-16" data-id="element-76">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-77">
          Qué incluye (exacto)
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-78">
          Sin relleno. Solo las herramientas que necesitas para recuperar tu
          calma funcional.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-79">
        {items.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-warm-white p-8 rounded-2xl border border-warm-gray hover:border-teal/30 transition-colors" data-id="element-80">
            <div className="flex items-start gap-4 mb-6" data-id="element-81">
              <div className="bg-white p-3 rounded-xl shadow-sm text-teal" data-id="element-82">
                <item.icon className="h-6 w-6" data-id="element-83" />
              </div>
              <div data-id="element-84">
                <h3 className="text-xl font-bold text-navy" data-id="element-85">{item.title}</h3>
                <p className="text-gray-500 font-medium" data-id="element-86">{item.subtitle}</p>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-87">
              {item.details.map((detail, i) => <li key={i} className="flex items-start text-gray-700" data-id="element-88">
                  <span className="h-1.5 w-1.5 rounded-full bg-teal mt-2 mr-3 flex-shrink-0" data-id="element-89" />
                  {detail}
                </li>)}
            </ul>
          </motion.div>)}
      </div>
    </Section>;
}